<template>
<v-app class="vapp">
  <meta name="description" content="F&uuml;r eine aufgeklärte, emanzipierte und sozial aktive Moschee in Leipzig">
  <div class="container">
        <div class="section-header">
            <img :src="require('@/images/Logo.png')" alt="Logo" /><br/>
            <h1>Abu Dharr Moschee Leipzig</h1><br/>
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Basmala.svg/1920px-Basmala.svg.png" style="max-width: 75%; height: auto;" alt="Bismillahirrahmanirrahim" />
        </div>

        <section class="vision-goals">
            <h2>Vision und Zielsetzung</h2>
            <p>
                Die <strong>Abu Dharr Moschee</strong> in Leipzig soll eine hierarchiefreie, aufgeklärte, und sozial engagierte muslimische Gemeinschaft werden. 
                Inspiriert vom Prophetengefährten <a href="https://de.wikipedia.org/wiki/Ab%C5%AB_Dharr_al-Ghif%C4%81r%C4%AB" target="_blank">Abū Dharr al-Ghifārī</a>, 
                der für seine Kritik an Herrschaft und sozialer Ungleichheit bekannt ist, soll sie für eine islamische Praxis stehen, die sich aktiv für Gleichheit, 
                diesseitige Gerechtigkeit, offenen Diskurs und religiöse Mündigkeit aller Gläubigen einsetzt - eine Praxis, wie sie in jüngerer Vergangenheit 
                von <a href="https://de.wikipedia.org/wiki/Ali_Schariati" target="_blank">Ali Schariati</a>, 
                <a href="https://de.wikipedia.org/wiki/Malcolm_X" target="_blank">Malcolm X</a>, 
                <a href="https://de.wikipedia.org/wiki/Muhammad_Abduh" target="_blank">Muhammad Abduh</a> und 
                <a href="https://en.wikipedia.org/wiki/%C4%B0hsan_Elia%C3%A7%C4%B1k" target="_blank">İhsan Eliaçık</a> 
                auf unterschiedliche Weise formuliert und erprobt, und in frühislamischer Zeit vielleicht von den 
                <a href="https://theanarchistlibrary.org/library/patricia-crone-ninth-century-muslim-anarchists#toc9" target="_blank">Naǧdīya</a>, 
                <a href="https://de.wikipedia.org/wiki/Mu%CA%BFtazila" target="_blank">Muʿtazila</a>,
                <a href="https://de.wikipedia.org/wiki/Br%C3%BCder_der_Reinheit" target="_blank">"Br&uuml;dern der Reinheit"</a> und manchen
                <a href="https://de.wikipedia.org/wiki/Sah%C4%81ba" target="_blank">Sahāba</a> bereits vorgelebt wurde.
            </p>
        </section>

        <section class="values">
            <h2>Grundsätze und Werte</h2>
            <ul>
                <li><strong>Soziale Gerechtigkeit</strong> – Die Moschee wird sich in lokalen und globalen sozialen Bewegungen engagieren, insbesondere in den Bereichen Armutsbekämpfung, Arbeitsrechte und Umweltschutz.</li>
                <li><strong>Aufklärung und Bildung</strong> – Sie wird ein Zentrum für kritische islamische Theologie, interdisziplinäre Bildung und offenen Diskurs bieten.</li>
                <li><strong>Inklusivität und Gleichberechtigung</strong> – Alle Gläubigen sollen gleichen Zugang zu allen Bereichen der Moschee und deren Entscheidungsstrukturen haben, unabhängig von Geschlecht, sexueller Orientierung, Herkunft und Alter. Frauen sollen das Gebet für Frauen leiten und predigen dürfen. Anders- und Nicht-Gläubige sind immer willkommen.</li>
                <li><strong>Interreligiöser Dialog und Kooperation</strong> – Die Moschee wird mit anderen muslimischen, christlichen, jüdischen und säkularen Gruppen in Dialog treten und versuchen zusammenzuarbeiten.</li>
            </ul>
        </section>

        <section class="activities">
            <h2>Geplante Aktivitäten</h2>
            <ul>
                <li>Freitagsgebete mit kritischen Predigten, die sich mit sozialen Fragen befassen</li>
                <li>Bildungsprogramme zu Islam, Philosophie, Geschichte und aktuellen gesellschaftlichen Themen</li>
                <li>Soziale Projekte: Unterstützung für Geflüchtete, Obdachlose und benachteiligte Gruppen in Leipzig</li>
                <li>Workshops und Diskussionsrunden mit progressiven muslimischen DenkerInnen und AktivistInnen</li>
                <li>Kunst- und Kulturveranstaltungen</li>
            </ul>
        </section>

        <section class="structure">
            <h2>Struktur und Organisation</h2>
            <ul>
                <li>Demokratische Selbstverwaltung in Plena und AGs</li>
                <li>Transparente Finanzstrukturen, strikt ohne jeglichen Profit für alle Beteiligten</li>
                <li>Offene Gemeindetreffen zur Information und Mitbestimmung</li>
            </ul>
        </section>

        <section class="steps">
            <h2>Erste Schritte</h2>
            <ul>
                <li>Gründung eines eingetragenen Vereins</li>
                <li>Suche eines geeigneten Ortes und Gebäudes</li>
                <li>Konkrete Planung erster Projekte</li>
            </ul>
        </section>

        <!--<section class="long-term-vision">
            <h2>Langfristige Vision</h2>
            <p>
                Die <strong>Abu Dharr Moschee</strong> Leipzig kann, in šā&#x2BE;a Llāh, auch über Leipzig hinaus ein Modell für einen freien und aufgeklärten Islam werden. Sie soll nicht nur ein offener Gebetsraum werden, sondern auch langfristig eine Plattform für kritisches Denken und sozialen Aktivismus.
            </p>
        </section>-->

        <section class="long-term-vision">
            <h2>Kontakt und Mitmachen</h2>
            <p>
                Das Projekt ist gerade erst im Aufbau, es ist noch nichts in Stein gemeißelt, auch der Name, Programm, und Struktur nicht. Das soll es ohnehin nie werden, sondern immer offen für Debatten bleiben. Für weitere Informationen, und insbesondere wer mitmachen möchte, schreibt gerne, auch nur mit neuen Ideen oder anderen Meinungen!
            </p>
        </section>

        <section style="text-align:center;align:center">
        <v-btn class="ma-2" outlined color="black"
        :href="'mailto:salam@abudharr.org'">
          salam@abudharr.org
        </v-btn>
        <!--<br/>
        <v-btn class="ma-2" outlined color="black"
        :href="'https://signal.group/#CjQKILJXSUSpIk0ZkZtp0XQGutKCIvfh4AMrTygnBOPOCQv4EhA0mtEYeVs9BUkE6N2qWmYa'">
          join signal group
        </v-btn>-->
        </section>
        <!--<section class="long-term-vision">
            <h2>Links</h2>
            <p>
                Ein paar sehr verschiedene historische Analysen und Entwürfe eines freien und sozial verantwortlichen Islams. Das ist nur eine lose Sammlung, in allem steht manches Gutes und Wahres, in allem steht mancher Murks. Allāhu aʿlam. "Prüft alles und behaltet das Gute" &#x2764;
            </p>
            <ul>
                <li><a href="https://theanarchistlibrary.org/library/patricia-crone-ninth-century-muslim-anarchists" target="_blank">Ninth-Century Muslim Anarchists - Patricia Crone</a></li>  
                <li><a href="https://www.iranchamber.com/personalities/ashariati/works/fatima_is_fatima1.php" target="_blank">Fatima is Fatima - Ali Shariati</a></li>
                <li><a href="https://www.iranchamber.com/personalities/ashariati/works/where_shall_we_begin.php" target="_blank">Where shall we begin? - Ali Shariati</a></li>
                <li><a href="https://theanarchistlibrary.org/library/anthony-t-fiscella-varieties-of-islam-anarchism-zine-pamphlet" target="_blank">Varieties of Islamic Anarchism - Anthony T. Fiscella</a></li>  
                <li><a href="https://theanarchistlibrary.org/library/federico-battistutta-islam-and-anarchy" target="_blank">Islam and anarchy - Federico Battistutta</a></li>  
                <li><a href="https://theanarchistlibrary.org/library/mohamed-jean-veneuse-anarca-islam" target="_blank">Anarca-Islam - Mohamed Abdou</a></li>
            </ul>
        </section>-->
        </div>
  </v-app>
</template>

<script>
export default {
  name: 'Home'
};
</script>

<style scoped>
        .vapp {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            margin: 0;
            padding: 0;
            background-color: #f4f4f4;
            color: #333;
        }

        .container {
            width: 80%;
            margin: 0 auto;
            padding: 20px;
            background-color: white;
            text-align: justify;
        }

        h1 {
            color: #1a1a1a;
        }

        h2 {
            color: #1a1a1a;
            font-weight: 500;
        }

        p {
            margin-bottom: 15px;
        }

        ul {
            list-style-type: square;
            margin-left: 20px;
        }

        .section-header {
            background-color: white;
            color: white;
            padding: 10px;
            margin-bottom: 20px;
            text-align: center;
        }

        .vision-goals, .values, .activities, .structure, .steps {
            margin-bottom: 40px;
        }

        footer {
            text-align: center;
            font-size: 14px;
            margin-top: 40px;
            color: #666;
        }
        
        a {
            text-decoration: none;
        }

        a:hover {
            text-decoration: underline;
        }

        @media (max-width: 600px) {
        .container {
          width: 100%;
          padding: 15px; /* Optionally reduce padding for smaller screens */
        }
}
</style>
